export const redirectToLogin = (callbackUrl) => {
  const encodedCallbackUrl = window.btoa(callbackUrl);
  window.location.href = `/auth/v1/login?call-back-url=${encodedCallbackUrl}&isRedirected=true`;
};
